/**
 * TaskComments Component Constants
 * UI dimensions, thresholds, and icon sizes
 */

// ===== SCROLL BEHAVIOR =====

/** Distance from bottom (pixels) to consider "near bottom" for auto-scroll */
export const SCROLL_NEAR_BOTTOM_THRESHOLD = 100;

// ===== ICON SIZES =====

/** Empty state icon size (pixels) */
export const COMMENT_EMPTY_STATE_ICON_SIZE = 48;

/** Menu action icon size - small (pixels) for copy/delete */
export const COMMENT_MENU_ICON_SIZE_SM = 14;

/** Menu action icon size - medium (pixels) for edit */
export const COMMENT_MENU_ICON_SIZE_MD = 16;

/** Scroll button icon size (pixels) */
export const COMMENT_SCROLL_BUTTON_ICON_SIZE = 16;

/** Send/Edit button icon size (pixels) */
export const COMMENT_ACTION_BUTTON_ICON_SIZE = 16;

// ===== PRESENCE INDICATOR =====

/** Presence indicator dot size (pixels) — matches workspace members list */
export const PRESENCE_INDICATOR_SIZE = 10;

/** Presence indicator offset from avatar edge (pixels) */
export const PRESENCE_INDICATOR_OFFSET = 2;

/** Presence indicator color (online status) */
export const PRESENCE_INDICATOR_COLOR = 'var(--app-status-completed)';

/** Presence indicator color (away status) */
export const PRESENCE_INDICATOR_AWAY_COLOR = 'var(--app-status-delayed)';

// ===== MENU DIMENSIONS =====

/** Message context menu width (pixels) */
export const COMMENT_MENU_WIDTH = 200;

// ===== TEXTAREA CONFIGURATION =====

/** Minimum rows for message input textarea */
export const COMMENT_INPUT_MIN_ROWS = 1;
